module.exports = __webpack_public_path__ + "img/8.ffbd0983.png";